import { handleActions } from 'redux-actions';
import { Intent, PaymentMethodType, PaymentMethodBasicInfo } from '@airwallex/airwallex-payment-elements';
import { Product } from '~models/orderSummary';
import { DccData } from '~models/dccElement';

export const INTENT_ACTION = 'CHECKOUT/INTENT/SET';

export interface OrderType {
  type: string;
  products: Product[];
  shipping: {
    first_name: string;
    last_name: string;
    phone_number: string;
    email: string;
    shipping_method: string;
    address: {
      country_code: string;
      state: string;
      city: string;
      street: string;
      postcode: string;
    };
  };
}

export type IntentState = Intent & {
  order?: OrderType;
  available_payment_method_types?: PaymentMethodType[];
  latest_payment_attempt?: {
    payment_method: PaymentMethodBasicInfo;
  };
  merchant_order_id?: string;
  descriptor?: string;
  customer_payment_methods?: [
    {
      id: string;
      card: {
        brand: string;
        last4: string;
        bin: string;
      };
    },
  ];
  next_action?: {
    url?: string;
    data?: {
      jwt: string;
      stage: string;
      version?: string;
    };
    type?: string;
    dcc_data?: DccData;
  };
};

export const reducer = handleActions(
  {
    [INTENT_ACTION]: (_, action) => {
      const { latest_payment_attempt, ...rest } = action?.payload ?? {};
      return rest || {};
    },
  },
  {} as IntentState,
);

export default reducer;
